// Duplicate of store/data/types.ts. Should move that enum here and update references.
// Resolve in https://geotab.atlassian.net/browse/MYG-106293
export enum ServerSwitches {
    None = 0,
    AllowThirdPartyLogging = 1
}

export function isAllowThirdPartyLoggingEnabled(serverFlags: number): boolean {
    return (serverFlags & ServerSwitches.AllowThirdPartyLogging) === ServerSwitches.AllowThirdPartyLogging;
}